// Wagmi configuration
import { Config, createConfig, http } from 'wagmi'
import { base, baseGoerli, baseSepolia } from 'wagmi/chains'
import {
  injected,
  metaMask,
  coinbaseWallet,
  walletConnect,
} from '@wagmi/connectors'

// Create wagmi config with multiple connectors
// @ts-ignore
export const config = createConfig({
  chains: [baseSepolia, baseGoerli, base],
  transports: {
    [baseGoerli.id]: http(),
    [baseSepolia.id]: http(),
    [base.id]: http(),
  },
  connectors: [
    injected(), // Any injected wallet
    metaMask(), // Specifically for MetaMask
    coinbaseWallet({
      appName: 'Libre alpha',
    }),
    walletConnect({
      projectId: '5bfe7f8b088436c797198b903a08f1b9', // Replace with your project ID from WalletConnect Cloud
      metadata: {
        name: 'Libre alpha',
        description: 'A portal for crypto data analysis',
        url: window.location.origin,
        icons: ['https://avatars.githubusercontent.com/u/37784886'],
      },
    }),
  ],
}) as Config
